import { jsx as _jsx } from "react/jsx-runtime";
import { AemComponentType } from '@as-react/common-types';
import { Prose, TextAlpha } from '@yonderland/andes-react';
import TeaserContainer from '../../../containers/TeaserContainer';
import { HtmlInclude } from '../html-include/HtmlInclude';
export const AemComponent = (component) => {
    switch (component[':type']) {
        case AemComponentType.TEXT_BLOCK_V2:
            return _jsx(TextAlpha, { children: component.richText ? _jsx(Prose, { html: component.text }) : component.text });
        case AemComponentType.TEXT:
            return (_jsx(TextAlpha, { children: _jsx(Prose, { html: component.text }) }));
        case AemComponentType.DIVIDER:
        case AemComponentType.CTA:
            return _jsx(HtmlInclude, { htmlFragment: component.html });
        case AemComponentType.TEASER_V2:
            return _jsx(TeaserContainer, Object.assign({}, component));
        default:
            return null;
    }
};
